import color from '../../text/color';

const primary = (params) => color(params);

export default primary;
